const VersionMenu = ({
  fragmentVersions,
  selectedVersion,
  onVersionSelect,
  fragmentsInUse,
  selectedFragment,
  viewingHistorical,
}) => {
  if (!fragmentVersions || fragmentVersions.length === 0) return null;

  return (
    <div className="mb-4">
      <label className="block text-gray-400 mb-1">
        {viewingHistorical ? "Viewing historical version" : "Latest version"}
      </label>
      <div className="flex items-center">
        <div className="relative ">
          <select
            className="appearance-none bg-gray-700 border border-gray-600 text-white py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:border-blue-500"
            value={selectedVersion || ""}
            onChange={(e) => onVersionSelect(e.target.value)}
          >
            {fragmentVersions.map((version, index) => {
              const versionNumber = fragmentVersions.length - index;
              const isCurrentVersionInUse =
                fragmentsInUse &&
                selectedFragment &&
                fragmentsInUse[selectedFragment.id] === versionNumber;

              return (
                <option key={version.id} value={version.id}>
                  v{versionNumber}
                  {isCurrentVersionInUse ? " (in use)" : ""}
                  {index === 0 ? " (latest)" : ""}
                </option>
              );
            })}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-white">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VersionMenu;
